export default "__VITE_ASSET__BJK6acXK__"